const SummaryType = {
  None: 'none',
  Quiz: 'quiz',
  Text: 'text'
};

export default SummaryType;
